import { useState, useEffect } from "react";
import { useNavigate, Link, useSearchParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { addUser, signIn, setError } from "./../../REDUX/Slices/users.Slice";
import {
  verifyToken,
  setPassword,
  resetPassword,
  authenticateUser,
} from "./../../REDUX/Models/users.Model";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./index.scss";

export default function ForgetPassword() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");

  const [inputs, setInputs] = useState({
    email: "",
    newPassword: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [tokenValid, setTokenValid] = useState(null); // null = not checked, true/false = checked
  const err = useSelector((state) => state.error);
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleChange = (e) => {
    setInputs({ ...inputs, [e.target.name]: e.target.value });
    dispatch(setError(null));
  };

  useEffect(() => {
    document.title = `طورنى - نسيت كلمة السر`;
    dispatch(setError(null));

    if (token) {
      // verify token on mount
      verifyToken({ token })
        .then((res) => {
          setTokenValid(true);
        })
        .catch(() => {
          setTokenValid(false);
          dispatch(setError("الرابط غير صالح أو انتهت صلاحيته."));
        });
    }
  }, [token]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    dispatch(setError(null));

    const passwordRegex =
      /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^A-Za-z\d])[^\s]{8,}$/;

    try {
      if (token) {
        if (!tokenValid) {
          dispatch(setError("الرابط غير صالح أو انتهت صلاحيته."));
          return;
        }

        if (!inputs.newPassword) {
          dispatch(setError("من فضلك أدخل كلمة المرور الجديدة!"));
          return;
        }

        if (!passwordRegex.test(inputs.newPassword)) {
          toast.error(
            "كلمة المرور يجب أن تحتوي على 8 أحرف على الأقل، حرف كبير، حرف صغير، رقم، ورمز خاص."
          );
          return;
        }

        await setPassword({ token, newPassword: inputs.newPassword });

        // Extract email from token payload
        const payload = await verifyToken({ token });
        const emailFromToken = payload.data.payload.email;

        await authenticateUser({
          email: emailFromToken,
          password: inputs.newPassword,
        }).then((res) => {
          const { response, token } = res.data.user;
          dispatch(addUser({ response, token }));
          dispatch(signIn());
        });

        navigate("/loading", { replace: true });
        toast.success("تم تحديث كلمة المرور بنجاح .. جارى التسجيل");
      } else {
        if (!inputs.email) {
          dispatch(setError("من فضلك أدخل البريد الإلكتروني!"));
          return;
        }

        await resetPassword({ email: inputs.email });
        toast.success(
          "تم إرسال رابط إعادة تعيين كلمة المرور إلى بريدك الإلكتروني."
        );
      }
    } catch (err) {
      let errorMsg = "حدث خطأ، يرجى المحاولة لاحقًا.";
      const status = err?.response?.status;
      if (status === 404) {
        errorMsg = token
          ? "الرابط غير صالح أو انتهت صلاحيته."
          : "البريد الإلكتروني غير موجود.";
      } else if (status === 500) {
        errorMsg = "خطأ في الخادم. حاول مرة أخرى لاحقًا.";
      }

      dispatch(setError(errorMsg));
    }
  };

  if (token && tokenValid === false) {
    return (
      <div className="resetPassword">
        <div className="container">
          <div className="row">
            <div className="form">
              <h2>الرابط غير صالح أو انتهت صلاحيته</h2>
              <Link to="/reset-password">طلب رابط جديد</Link>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="resetPassword">
      <div className="container">
        <div className="row">
          <div className="form">
            <h2>{token ? "إعادة تعيين كلمة السر" : "نسيت كلمة السر"}</h2>

            <form onSubmit={handleSubmit}>
              {token ? (
                <div className="input-field">
                  <input
                    type={showPassword ? "text" : "password"}
                    name="newPassword"
                    placeholder="كلمة المرور الجديدة"
                    value={inputs.newPassword}
                    required
                    onChange={handleChange}
                  />
                  <i
                    className={`fa-light ${
                      showPassword ? "fa-lock-open" : "fa-lock"
                    } input-icon`}
                    onClick={() => setShowPassword((prev) => !prev)}
                    style={{ cursor: "pointer" }}
                  ></i>
                </div>
              ) : (
                <div className="input-field">
                  <input
                    type="email"
                    name="email"
                    placeholder="البريد الالكترونى"
                    value={inputs.email}
                    required
                    onChange={handleChange}
                  />
                  <i className="fa-light fa-envelope input-icon"></i>
                </div>
              )}

              <button type="submit">
                {token ? "تحديث كلمة السر" : "إرسال الرابط"}
              </button>
            </form>

            <div className="links">
              <Link to="/login">تسجيل دخول</Link>
              <Link to="/register">تسجيل حساب جديد</Link>
              {err && <span className="error">{err}</span>}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
